<template>
	<div class="flex flex-col">
		<header class="bg-white shadow" v-if="title">
			<div
				class="py-6 px-4 sm:px-6 lg:px-8 sm:flex sm:items-center sm:justify-between"
			>
				<h1
					:class="[
						titleIsBold
							? 'text-3xl font-bold leading-tight text-gray-900'
							: 'text-xl leading-tight text-gray-900',
					]"
					v-if="!hideTitle"
				>
					{{ title }}
				</h1>
				<div v-if="showActionButton">
					<div class="px-6">
						<ui-button
							type="secondary"
							v-on:click="$inertia.visit(actionButtonTarget)"
							class="flex items-center"
						>
							{{ __(actionButtonCaption) }}
						</ui-button>
					</div>
				</div>

				<div class="flex items-center">
					<slot name="actions"></slot>

					<div class="mt-3 sm:mt-0 sm:ml-4" v-if="!gridRef">
						<label for="search" class="sr-only">Search</label>
						<div class="flex rounded-md shadow-sm">
							<div class="relative flex-grow focus-within:z-10">
								<div
									class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
								>
									<ui-icon
										class="flex-shrink-0 h-5 w-5 text-gray-400"
										name="search"
										stroke-width="2"
									/>
								</div>
								<input
									type="text"
									id="search"
									class="focus:ring-orange-500 focus:border-orange-500 w-full rounded-md pl-10 sm:block sm:text-sm border-gray-300"
									:placeholder="__('Search')"
									v-model="searchInput"
								/>
							</div>
						</div>
					</div>
					<div v-else>
						<ui-button
							v-on:click="$bus.$emit('toggle-iframe-modal', gridRef.link)"
							label=""
							class="flex items-center"
						>
							<ui-icon
								name="search"
								stroke-width="2"
								class="-ml-1 w-5 h-5 mr-2"
							/>
							{{ gridRef.label }}
						</ui-button>
					</div>
				</div>

			</div>
		</header>

		<div class="-my-2 sm:-mx-6 lg:-mx-8">
			<!--overflow-x-auto-->
			<div class="p-4">
				<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
					<div
						class="shadow border-b border-gray-200 sm:rounded-lg"
						style="min-height: 18rem"
					>
						<!--overflow-hidden-->
						<table class="min-w-full divide-y divide-gray-200 relative">
							<thead class="bg-gray-700">
								<tr>
									<td class="px-2 py-4" v-if="showCheckBox"></td>
									<th
										scope="col"
										v-for="col in cols"
										:key="col.id"
										v-bind:class="{ active: col.id == form.orderBy }"
										class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider sticky top-0 bg-gray-700 text-white"
									>
										<button
											v-if="!col.filterOptions"
											v-on:click.prevent="toggleSort(col.id)"
											class="btn flex uppercase font-semibold text-white"
											v-bind:class="{
												'text-gray-900 font-medium': col.id == form.orderBy,
												'': col.id != form.orderBy,
											}"
										>
											<span v-bind:class="{ '': col.id != form.orderBy }">
												{{ col.name }}
											</span>

											<ui-icon
												v-if="col.id == form.orderBy && col.id == 'id'"
												class="ml-1 flex-shrink-0 h-4 w-4 -mr-1"
												:name="
													form.orderByAscending ? 'arrow-down' : 'arrow-up'
												"
												stroke-width="2"
											/>

											<ui-icon
												v-else-if="col.id == form.orderBy"
												class="ml-1 flex-shrink-0 h-4 w-4 -mr-1"
												:name="
													form.orderByAscending ? 'arrow-down' : 'arrow-up'
												"
												stroke-width="2"
											/>

											<span v-else>
												<i class="fa fa-fw fa-arrows-alt-v text-muted"></i>
											</span>
										</button>

										<!-- New dropdown -->

										<div class="relative" v-else>
											<ui-dropdown
												button-class="items-center inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-orange-500"
											>
												<template v-slot:button>
													<span class="sr-only">Open user menu</span>
													{{ form.colFilter[col.id] || col.name }}
													<ui-icon
														class="ml-2 flex-shrink-0 h-4 w-4 -mr-1"
														name="chevron-down"
														stroke-width="2"
													/>
												</template>
												<template v-slot:items>
													<span>
														<div
															class="block px-4 py-2 text-gray-700"
															v-for="option in col.filterOptions"
															:key="option.id"
														>
															<div class="flex items-center">
																<input
																	type="radio"
																	class="focus:ring-orange-400 h-4 w-4 text-orange-500 border-gray-300"
																	v-bind:id="'radio' + option.id"
																	v-model="form.colFilter[col.id]"
																	v-bind:value="option.id"
																	v-bind:name="'filter-' + col.id"
																/>
																<label
																	class="ml-3 block text-sm font-medium text-gray-700"
																	v-bind:for="'radio' + option.id"
																	>{{ option.name }}</label
																>
															</div>
														</div>
														<div class="block px-4 py-2 text-gray-700">
															<div class="flex items-center">
																<input
																	type="radio"
																	class="focus:ring-orange-400 h-4 w-4 text-orange-500 border-gray-300"
																	v-bind:id="'radio' + col.id"
																	v-model="form.colFilter[col.id]"
																	v-bind:value="null"
																	v-bind:name="'filter-' + col.id"
																/>
																<label
																	class="ml-3 block text-sm font-medium text-gray-700"
																	v-bind:for="'radio' + col.id"
																	>{{ __("No filter") }}</label
																>
															</div>
														</div>
													</span>
												</template>
											</ui-dropdown>
										</div>

										<!-- consider button group for fewer clicks
                                        and more affordance-->
										<!--
										<span class="relative z-0 inline-flex shadow-sm rounded-md">
											<button type="button" class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
												{{ __('All') }}
											</button>
											<button type="button" class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
												Months
											</button>
											<button type="button" class="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
												Days
											</button>
										</span>
                                        -->
									</th>
								</tr>
							</thead>
							<tbody class="bg-white divide-y divide-gray-200">
								<tr
									v-for="(row, idx) in filteredPaginatedRows"
									:key="idx"
									v-on:click="rowOnClick(row)"
									class="cursor-pointer hover:bg-gray-50 active:bg-gray-150"
								>
									<td class="px-2 py-4" v-if="showCheckBox">
										<input
											type="checkbox"
											v-model="row.checked"
											@click="toggle(row.id)"
											class="mt-0.5 h-5 w-5 border-gray-300 hover:border-gray-500 rounded text-orange-500 focus:ring-orange-500 cursor-pointer"
										/>
									</td>
									<td
										scope="col"
										v-for="col in cols"
										:key="col.id"
										class="px-4 py-4"
										:class="noWrap ? 'whitespace-nowrap' : ''"
									>
										<a :href="rowHref(row)" v-on:click.prevent="">
											<component
												v-if="col.component"
												v-bind:is="col.component"
												:row="row"
												:col="col"
											/>
											<span v-else-if="row[col.id] == null">
												<i>{{ __("n/a") }}</i>
											</span>
											<crop-timeago
												v-else-if="col.timeago"
												:date="row[col.id]"
											/>
											<span v-else>{{ row[col.id] }}</span>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div v-if="shouldPaginate" class="row">
			<div class="p-4">
				<div class="flex justify-between pt-2 pb-2">
					<span>
						<ui-button
							@click="paginate('back')"
							v-if="start > 0"
							label="Back"
						/>
					</span>
					<span>
						{{ filteredPaginatedRows.length }} {{ __("out of") }}
						{{ filteredRows.length }} {{ __("results") }}
					</span>
					<span>
						<ui-button
							@click="paginate('next')"
							v-if="start + itemsPerPage < filteredRows.length"
							label="Next"
						/>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import { debounce } from "lodash";
export default {
	props: {
		rows: {
			type: Array,
			required: true,
		},
		cols: {
			type: Array,
			required: true,
		},
		customFilter: {
			type: Function,
			required: false,
		},
		rowHref: {
			type: Function,
			required: false,
			default: () => null,
		},
		rowOnClickHandler: {
			type: Function,
			required: false,
			default: null,
		},
		defaultOrderBy: {
			type: String,
			required: false,
			default: "id",
		},
		defaultOrderByAscending: {
			type: Boolean,
			required: false,
			default: true,
		},
		title: {
			type: String,
			required: false,
		},
		openModal: {
			type: Boolean,
			required: false,
			default: false,
		},
		shouldPaginate: {
			type: Boolean,
			required: false,
			default: true,
		},
		titleIsBold: {
			type: Boolean,
			required: false,
			default: true,
		},
		gridRef: {
			type: Object,
			required: false,
		},
		hideTitle: {
			type: Boolean,
			required: false,
			default: false,
		},
		showCheckBox: {
			type: Boolean,
			required: false,
			default: false,
		},
		showActionButton: {
			type: Boolean,
			required: false,
			default: false,
		},
		actionButtonCaption: {
			type: String,
			required: false,
		},
		actionButtonTarget: {
			type: String,
			required: false,
		},
		noWrap: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	data() {
		return {
			form: Vue.observable({
				search: "",
				orderBy: this.defaultOrderBy,
				orderByAscending: this.defaultOrderByAscending,
				colFilter: {},
			}),
			showDropdown: false /* to do: allow more than one dropdown */,
			searchInput: "",
			start: 0,
			itemsPerPage: 50,
		};
	},
	watch: {
		searchInput: debounce(function () {
			// more fluid interface: do not filter results by search until 300 ms have passed since last keystroke
			this.form.search = this.searchInput;
			this.start = 0;
		}, 300),
		form: {
			handler(newValue) {
				this.start = 0;
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		filteredRows() {
			let s = this.form.search,
				f = this.form.colFilter,
				renderedRows = this.renderValues(this.rows),
				filteredRows = renderedRows.filter(this.customFilter || this.rowFilter);
			if (this.form.orderBy) {
				filteredRows = filteredRows.sort((a, b) => {
					let valA = a[this.form.orderBy],
						valB = b[this.form.orderBy];
					if (valA && typeof valA == "string") {
						valA = valA.toLowerCase();
						if (valA.match("^#")) {
							valA = 1 * valA.substr(1);
						} else if (valA.match("€$")) {
							valA = 1 * valA.substr(0, valA.length - 1);
						}
					}
					if (valB && typeof valB == "string") {
						valB = valB.toLowerCase();
						if (valB.match("^#$")) {
							valB = 1 * valB.substr(1);
						} else if (valB.match("€$")) {
							valB = 1 * valB.substr(0, valB.length - 1);
						}
					}
					let aIsBigger = valA >= valB;
					if (this.form.orderByAscending) {
						return aIsBigger ? 1 : -1;
					} else {
						return aIsBigger ? -1 : 1;
					}
				});
			}
			return filteredRows;
		},
		filteredPaginatedRows() {
			return this.shouldPaginate
				? this.filteredRows.slice(this.start, this.start + this.itemsPerPage)
				: this.filteredRows;
		},
	},
	methods: {
		renderValues(rows) {
			let that = this,
				transformed = (rows || []).map((row) => {
					let out = {};
					that.cols.map((col) => {
						out[col.id] = col.render
							? col.render(row[col.id], row)
							: row[col.id];
					});
					out["checked"] = row.checked;
					return out;
				});
			return transformed;
		},
		rowFilter(row) {
			// first, check if the colFilters do not match
			let that = this,
				reject = false;
			Object.keys(that.form.colFilter).map((colId) => {
				let filterVal = that.form.colFilter[colId];
				if (filterVal == null || row[colId]?.trim() == filterVal.trim()) {
					// this row is fine
				} else {
					reject = true;
				}
			});
			if (reject) {
				return false;
			}
			// now, each word in the search query should appear somewhere in the displayed fields
			let str = Object.values(row).join(" ");
			let terms = this.form.search.split(" "),
				noMatch = terms.filter((t) => {
					// if the term does not appear in the search string, indexOf == -1
					return str.toLowerCase().indexOf(t.toLowerCase()) == -1;
				});
			return noMatch.length == 0;
		},
		rowOnClick(row) {
			if (this.rowOnClickHandler) {
				return this.rowOnClickHandler(row);
			}
			if (!this.rowHref) {
				return true;
			}
			let targetUrl = this.rowHref(row);
			if (!(targetUrl === null)) {
				console.log(targetUrl);
				this.$inertia.get(targetUrl);
			}
		},
		toggleSort(colId) {
			if (this.form.orderBy == colId) {
				this.form.orderByAscending = !this.form.orderByAscending;
			} else {
				this.form.orderBy = colId;
				this.form.orderByAscending = true;
			}
		},
		paginate: function (direction) {
			if (direction === "next") {
				this.start += parseInt(this.itemsPerPage);
			} else if (direction === "back") {
				this.start -= parseInt(this.itemsPerPage);
			}
		},
		toggle(id) {
			let ids = id.replace("#", "");
			Object.keys(this.rows).forEach((o) => {
				if (this.rows[o].id == ids) {
					this.rows[o].checked = !this.rows[o].checked;
				}
			});
		},
	},
	created() {},
};
</script>
